import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import fetchAPI, { ApiResponse, Pagination } from "../../../utils/api";
import { Company } from "../../company-page/store/slice";
import companySlice from "./slice";

type CompanyResponse = ApiResponse<{ data: Company[]; meta: Pagination }>;

function* companySaga() {
  yield takeLatest(companySlice.actions.fetchData, handleFetch);
}

function* handleFetch({ payload: name }: PayloadAction<string>) {
  const response: CompanyResponse = yield call(
    fetchAPI,
    `/companies?search=${name}`
  );

  if (response && response.data && response.meta) {
    yield put(companySlice.actions.setData(response));
  }

  yield put(companySlice.actions.setIsLoading(false));
}

export default companySaga;
